/**
 * Safe post-login redirect from React Router location.state.from.
 * Avoids "undefined" string when pathname is missing (bad operator precedence).
 */
export const resolveLoginRedirect = (location, fallback = '/') => {
  const from = location?.state?.from;
  if (!from?.pathname || typeof from.pathname !== 'string') return fallback;

  const pathname = from.pathname.trim();
  if (!pathname.startsWith('/') || pathname === '/login') return fallback;

  const search = typeof from.search === 'string' ? from.search : '';
  const target = `${pathname}${search}`;

  if (target.includes('undefined') || target.includes('null')) return fallback;

  return target;
};
